// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__GQ3jW","rotation":"Spinner_rotation__fvANO"};